gsap.registerPlugin(ScrollTrigger);
//gsap.registerPlugin(toggleClass)
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";

const actuAnim = {
  init() {
    document.addEventListener("DOMContentLoaded", () => {
      
      //let actuTitles = document.querySelectorAll("h2");

      
      /* SECTION CREATIONS */
      /* gsap.from(actuTitles, {
        scrollTrigger: {
          
          trigger:'h2',
          markers: true,
          start: 'top 75%',
          //scrub: true,
          toggleActions: "play none none reverse",
        },
        opacity: 0,
        x:100,
      },)
      ; */
      let actuTitles = gsap.utils.toArray('h2');

      actuTitles.forEach((element) => {
        const q = gsap.utils.selector(element);
         const tl = gsap.timeline({
            scrollTrigger: {
              trigger: element,
              start: 'top 75%',
              markers: false,
              toggleActions: "play none none reverse",
            }
          });
        
          tl.from(q(element), {
            x:-100,
            opacity: 0,
          });

      })  
  

    });
  },
};

export default actuAnim;
